import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl'
import { each } from 'lodash'

import { callApi } from '../services/fetchService'
import { getSelectOptions } from '../services/selectService'

import FaIcon from '../components/FaIcon'
import DataTable from '../components/DataTable'

import { Select, Card, message } from 'antd'


class Report4 extends Component {

    static propTypes = {
        comboboxes: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        intl: intlShape.isRequired
    }
    
    state = {
        pathology: null,
        data: null,
        loading: false
    }

    fetch = () => {
        const { intl } = this.props
        this.setState({ loading: true })
        callApi({
            endpoint: 'reports/4/' + this.state.pathology 
        }).then((data) => {
            each(data.stats, (item) => {
                item.fullName = intl.formatMessage({id: 'biology.' + item.group + '.' + item.name})
                item.key = item.group + '.' + item.name
            })
            this.setState({
                data: data,
                loading: false
            })
        }).catch((data) => {
            message.error(intl.formatMessage({id: 'misc.unknownError'}))
            this.setState({ loading: false })
        })
    }

    componentDidMount() {
        this.fetch()
    }

    onChangePathology = (value) => {
        this.setState({ pathology: value }, this.fetch)
    }

    rowsConfig = (record) => ({
        style: { cursor: 'pointer' },
        onClick: (e) => this.props.history.push('/patient/' + record.id)
    })

    render() {
        const { data, loading, pathology } = this.state

        const patientsColumns = [
            { title: "patients.nameColumn", dataIndex: "fullName", type: "string", sorter: true },
            { title: "patients.consultationsColumn", dataIndex: "numberOfConsultations", type: "number", sorter: true },
            { title: "patients.bloodTestsColumn", dataIndex: "numberOfBloodTests", type: "number", sorter: true }
        ]

        const statsColumns = [
            { title: "reports.report4.element", dataIndex: "fullName", type: "string", sorter: true },
            { title: "reports.report4.above", dataIndex: "above", type: "number", sorter: true },
            { title: "reports.report4.below", dataIndex: "below", type: "number", sorter: true },
            { title: "reports.report4.in", dataIndex: "in", type: "number", sorter: true }
        ]

        return (
            <div>
                <h1><FaIcon icon="chart-bar" fixedWidth /> <FormattedHTMLMessage id="reports.report4.title" /></h1>
                <div className="action-bar">
                    <Select defaultValue={pathology} style={{ width: 250 }} showSearch optionFilterProp="children" filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0} onChange={this.onChangePathology}>
                        {getSelectOptions('pathology', pathology)}
                    </Select>
                </div>
                <Card title={<span><FaIcon icon="users" /><FormattedMessage id="reports.report4.patients" /></span>}>
                    <DataTable loading={loading} columns={patientsColumns} dataSource={data ? data.patients : []} rowKey="id" size="middle" onRow={this.rowsConfig} export />
                </Card>
                <Card title={<span><FaIcon icon="chart-bar" /><FormattedMessage id="reports.report4.statistics" /></span>}>
                    <DataTable loading={loading} columns={statsColumns} dataSource={data ? data.stats : []} rowKey="key" size="middle" export />
                </Card>
            </div>
        )
    }

}

const mapStateToProps = (state, ownProps) => ({
    comboboxes: state.comboboxes
})

export default  withRouter(injectIntl(connect(mapStateToProps)(Report4)))


// WEBPACK FOOTER //
// ./src/views/Report4.js